/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".block-ui-wrapper {\n  background: rgba(0, 0, 0, 0.1); }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9zcmMvZWR1Sm91cm5hbC9DbGllbnRBcHAvc3JjL2VqLXRzL2xheW91dC9ibG9jay11aS10ZW1wbGF0ZS9ibG9jay11aS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksOEJBQThCLEVBQUEiLCJmaWxlIjoic3JjL2VqLXRzL2xheW91dC9ibG9jay11aS10ZW1wbGF0ZS9ibG9jay11aS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJsb2NrLXVpLXdyYXBwZXIge1xuICAgIGJhY2tncm91bmQ6IHJnYmEoMCwgMCwgMCwgMC4xKTtcbn0iXX0= */"];
export { styles as styles };
